import { type ResponseErrorGenerics } from '@dni-types/utilities/response'
import { queryStringify } from '@utils'
import { createMutationHelper, createRequestHelper } from '@utils/swr'
import { type CampaignAdminSearchOrdersRequest } from '../types/apiRequest'
import { type PaymentTransactionResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useMutation } = createMutationHelper<FortuneApis['get']['searchOrdersByCampaign'], PaymentTransactionResponse, CampaignAdminSearchOrdersRequest, ResponseErrorGenerics>({
  client: 'fastpassAdmin',
  key: '/campaigns',
  fetcher: (_url, { arg, client }) => {
    if (!arg.code) {
      return Promise.reject(new Error('Campaign code is required'))
    }
    if (!arg.order_hash) {
      return Promise.reject(new Error('Order hash is required'))
    }
    return client.get(`/campaigns/${arg.code}/admin/payment-transactions/search?${queryStringify({ order_hash: arg.order_hash })}`)
  },
})

export const useApiMutationAdminSearchOrdersByCampaignWithOrderHash = useMutation

const { useMutation: useMutationWithOrderId } = createMutationHelper<FortuneApis['get']['searchOrdersByCampaign'], PaymentTransactionResponse, CampaignAdminSearchOrdersRequest, ResponseErrorGenerics>({
  client: 'fastpassAdmin',
  key: '/campaigns',
  fetcher: (_url, { arg, client }) => {
    if (!arg.code) {
      return Promise.reject(new Error('Campaign code is required'))
    }
    if (!arg.id) {
      return Promise.reject(new Error('Order id is required'))
    }
    return client.get(`/campaigns/${arg.code}/admin/payment-transactions/search?${queryStringify({ id: arg.id })}`)
  },
})

export const useApiMutationAdminSearchOrdersByCampaignWithOrderId = useMutationWithOrderId

const { useRequest } = createRequestHelper<FortuneApis['get']['searchOrdersByCampaign'], PaymentTransactionResponse, CampaignAdminSearchOrdersRequest, ResponseErrorGenerics>({
  client: 'fastpassAdmin',
  key: params => params ? `/campaigns/${params.code}/admin/payment-transactions/search?${queryStringify({ id: params.id })}` : null,
})

export const useApiRequestAdminSearchOrdersByCampaignWithOrderId = useRequest
